import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

// ----- BOM TYPE ADD EDIT  ----- //

export const addBomType = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_TYPE.CREATE}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllGrading = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SPEC_TEMPLATE.ALL_GRADING}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getGradingById = async (data, gradingId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SPEC_TEMPLATE.ALL_GRADING}/${gradingId}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSpecTemplate = async (specObj) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SPEC_TEMPLATE.GET_PUT_SPEC_DETAIL}/${specObj.specTemplateId}`, {
      params: { ...specObj },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSpecTemplateSupportingDocument = async (specId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SPEC_TEMPLATE.SPEC_TEMP_SUPPORTING_DOC}/${specId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadPOMXlsxFileService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.POM.POM_EXCEL_SHEET_UPDATE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateSpecTemplate = async (specId, payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SPEC_TEMPLATE.GET_PUT_SPEC_DETAIL}/${specId}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateSpecTemplatePomSequence = async (specId, payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SPEC_TEMPLATE.GET_PUT_SPEC_DETAIL}/sequence/${specId}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveSpecTemplate = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SPEC_TEMPLATE.GET_PUT_SPEC_DETAIL}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveSpecTemplateSupportingDocument = async (specId, payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SPEC_TEMPLATE.SPEC_TEMP_SUPPORTING_DOC}/${specId}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateSpecDocument = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SPEC_TEMPLATE.SPEC_TEMP_SUPPORTING_DOC}/${payload.specTemplateId}/${payload.id}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteSpecTempDocument = async (payload, specTemplateId) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SPEC_TEMPLATE.SPEC_TEMP_SUPPORTING_DOC}/${specTemplateId}`, {
      data: { deletedData: payload },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchSpecList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SPEC_TEMPLATE.GET_PUT_SPEC_DETAIL}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteSpecLibrary = async (id, param) => {
  try {
    const queryString = new URLSearchParams(param).toString();
    return await apiClient.delete(`${apiEndpoint}${API.SPEC_TEMPLATE.GET_PUT_SPEC_DETAIL}/${id}?${queryString}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const MultiDeleteSpecLibrary = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SPEC_TEMPLATE.GET_PUT_SPEC_DETAIL}/1`, {
      data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicateSpecLibrary = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SPEC_TEMPLATE.DUPLICATE_SPEC_LIBRARY}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchBrand = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_BRANDS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchCategory = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_CATEGORY_1}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const retriveAllSpecTemplate = async (selectedGradingLib) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SPEC_TEMPLATE.ALL_SPECT_TEMPLATE}?selectedGradingLib=${selectedGradingLib}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addDocumentToLibrary = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SPEC_TEMPLATE.ADD_DOCUMENT_TO_LIBRARY}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const importDocumentToSpec = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SPEC_TEMPLATE.IMPORT_DOCUMENT_TO_SPEC}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
